module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt_BR":{"label":"Preview","placeholder":"Preview da sua mensagem.","tips":{"label":"Boas práticas","list":["Se a mensagem ultrapassar 160 caracteres, serão enviadas 2 (ou mais) mensagens, que consumirão 2 (ou mais) créditos.","Ao utilizar variáveis, como *|PRIMEIRO_NOME|*, sugerimos que deixe uma margem de segurança de 20 caracteres.","Sugerimos que, sempre que possível, ofereça a opção de opt-out para o usuário: “P/Cancelar, resp SAIR”"]}}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/Campaign/Preview.vue
// module id = 154
// module chunks = 0